import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

type LanguageValue = string | string[] | null | undefined;

@Pipe({
  name: 'languageList',
  pure: false,
})
export class LanguageListPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: LanguageValue): string {
    if (!value) {
      return '';
    }

    const values = Array.isArray(value) ? value : [value];
    const normalized = values
      .filter((lang): lang is string => typeof lang === 'string' && !!lang.trim())
      .map((lang) => lang.trim());

    if (!normalized.length) {
      return '';
    }

    const translated = normalized
      .map((lang) => this.translate.instant(lang))
      .filter((label) => !!label);

    return translated.join(', ');
  }
}





